import { element } from 'protractor';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { faHome,faCar,faDesktop,faSearch } from '@fortawesome/free-solid-svg-icons';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';


export interface Element {
  no: number;
  deviceID: string;
  action: string;
}

const ELEMENT_DATA: Element[] = [
  {no: 1, deviceID: 'GCU365000001', action:''},
  {no: 2, deviceID: 'GCU365000002', action:''},
  {no: 3, deviceID: 'GCU365000003', action:''},
  {no: 4, deviceID: 'GCU365000004', action:''},
  {no: 5, deviceID: 'GCU365000005', action:''},
];

@Component({
  selector: 'app-obd-list',
  templateUrl: './obd-list.component.html',
  styleUrls: ['./obd-list.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ObdListComponent implements OnInit {

  faHome = faHome;
  faCar = faCar;
  faSearch = faSearch;
  //deviceID = 'GCU365000002';
  
  displayedColumns = ['no', 'deviceID' , 'action'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  constructor(private router: Router,) { }

  ngOnInit() {
  }

  viewDeviceDetails(element){
    this.router.navigate(['/obd-list/obd-details', { deviceID: element.deviceID }]);
  }

}
